module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAxCAYAAABDEFA9AAABSElEQVRoQ+2Z0RGCMAyG/zqFukDH8PRN1xBdSlxD3+AcgwEUp7Aent4JliYWoajhOQ1/P5I/XKsQ6FlNsrkZYAuFESnBIFcXLBUZ2FJANM1OLKGP9xeCW9JCpo1mmSGDKgEilkNMyHIo+cQIWR9qnDWdkq019buBbw567xLdqVinqRvkcarH/RFLmHqcaKeHd0tWxLpb03vcUp9RyoDjibYYIUuQUyVzZxp6kTMI2RdzZxh6OLEWv6Q6WcQyOl3Zak/IVshRDWoDLWQLKlQpCdm6JqXICNnvsq7XA7JznGjyZC9MGUyzBRS2AIYAjjBYx6neUQMliFhKVK8aTMS2NRSErJAF/uTcwH3bQg4Wyqet/7PeDVYeJs9pWIOlU7G+m3ysE7FNCfqO64/WbNNNSBk0JfgbZfDurThw9p5gTYlH9T5tS33z7isnC1G/Q9Pn1AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/icon_5@2x.png
// module id = svFz
// module chunks = 70